/* Bhuka live demo — a working booking sandbox (customer widget + admin).
   Fun Life · funlife.co.za. No payments, no messages: state stays in this browser. */
(function () {
  'use strict';
  var root = document.querySelector('[data-bd]');
  if (!root) return;
  var shopEl = root.querySelector('[data-bd-shop]');
  var adminEl = root.querySelector('[data-bd-admin]');
  var grid = root.querySelector('[data-bd-grid]');
  var KEY = 'bhuka-demo-v1';
  var SITE = null;
  var cfgEl = root.querySelector('[data-bd-config]');
  if (cfgEl) { try { SITE = JSON.parse(cfgEl.textContent); } catch (e) { SITE = null; } }

  /* ---------------- helpers ---------------- */
  var DAYN = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var DAYL = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var money = function (n) { return 'R' + String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
  var ymd = function (d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); };
  var parse = function (s) { var p = s.split('-'); return new Date(+p[0], +p[1] - 1, +p[2]); };
  var addDays = function (d, n) { return new Date(d.getFullYear(), d.getMonth(), d.getDate() + n); };
  var now = new Date();
  var TODAY = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  var TODAY_S = ymd(TODAY);
  var dayLabel = function (s) { var d = parse(s); if (s === TODAY_S) return 'Today'; if (s === ymd(addDays(TODAY, 1))) return 'Tomorrow'; return DAYN[d.getDay()] + ' ' + d.getDate() + ' ' + MON[d.getMonth()]; };
  var dayLong = function (s) { var d = parse(s); return DAYL[d.getDay()] + ' ' + d.getDate() + ' ' + MON[d.getMonth()]; };
  var mins = function (t) { var p = t.split(':'); return +p[0] * 60 + +p[1]; };
  var tStr = function (m) { return pad(Math.floor(m / 60)) + ':' + pad(m % 60); };
  var isPast = function (date, time) { if (date > TODAY_S) return false; if (date < TODAY_S) return true; return mins(time) <= now.getHours() * 60 + now.getMinutes() + 30; };
  var hash = function (str) { var h = 2166136261; for (var i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 16777619); } return h >>> 0; };
  var rnd = function (str) { var t = hash(str) + 0x6D2B79F5; t = Math.imul(t ^ (t >>> 15), t | 1); t ^= t + Math.imul(t ^ (t >>> 7), t | 61); return ((t ^ (t >>> 14)) >>> 0) / 4294967296; };
  var store = {
    get: function () { try { return JSON.parse(window.localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } },
    set: function (v) { try { window.localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} },
    clear: function () { try { window.localStorage.removeItem(KEY); } catch (e) {} }
  };
  var sound = function (k) { try { if (window.FLSound && window.FLSound.on && window.FLSound[k]) window.FLSound[k](); } catch (e) {} };
  var ICON = {
    bag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 7h12l-1 13H7L6 7Z"/><path d="M9 7a3 3 0 0 1 6 0"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>',
    cal: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="4" width="18" height="18" rx="3"/><path d="M16 2v4"/><path d="M8 2v4"/><path d="M3 10h18"/><path d="m9 16 2 2 4-4"/></svg>',
    chat: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>',
    left: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>',
    right: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg>',
    close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12"/><path d="M18 6 6 18"/></svg>',
    lock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>',
    search: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>'
  };

  /* ---------------- demo businesses ---------------- */
  var BIZ = {
    art: {
      name: 'Studio Seven', kind: 'Art studio', domain: 'studioseven.co.za', deposit: { type: 'pct', value: 50 },
      upsell: { name: '“Lion’s Head at dusk” A3 print', price: 850 },
      services: [
        { id: 'collage', name: 'Collage & Mixed Media', short: 'Collage', sub: '2½-hour class · materials included', mins: 150, price: 360, cap: 12, unit: ['seat', 'seats'], days: [6, 0], times: ['10:00', '14:00'], names: 'Name for seat' },
        { id: 'life', name: 'Life Drawing', short: 'Life drawing', sub: '2-hour session · live model', mins: 120, price: 280, cap: 10, unit: ['seat', 'seats'], days: [2, 4], times: ['18:00'], names: 'Name for seat' },
        { id: 'kids', name: 'Kids Clay', short: 'Kids clay', sub: '90 minutes · ages 6 to 12', mins: 90, price: 220, cap: 8, unit: ['child', 'children'], days: [3, 6], times: ['09:30'], names: 'Child’s name' }
      ]
    },
    yoga: {
      name: 'Still Water Yoga', kind: 'Yoga studio', domain: 'stillwater.yoga', deposit: { type: 'full' },
      upsell: { name: 'Cork yoga block', price: 240 },
      services: [
        { id: 'flow', name: 'Vinyasa Flow', short: 'Vinyasa', sub: '60 minutes · all levels', mins: 60, price: 150, cap: 16, unit: ['spot', 'spots'], days: [1, 2, 3, 4, 5], times: ['06:30', '12:15', '18:00'] },
        { id: 'yin', name: 'Yin & Restore', short: 'Yin', sub: '75 minutes · candlelit', mins: 75, price: 170, cap: 14, unit: ['spot', 'spots'], days: [2, 4, 6], times: ['19:00'] },
        { id: 'private', name: 'Private session', short: 'Private', sub: '60 minutes · one-on-one', mins: 60, price: 650, cap: 1, unit: ['session', 'sessions'], days: [1, 2, 3, 4, 5, 6], times: ['08:00', '10:00', '15:00'] }
      ]
    },
    salon: {
      name: 'Mane Street', kind: 'Hair salon', domain: 'manestreet.co.za', deposit: { type: 'fixed', value: 200 },
      staff: ['Nomsa', 'Thabo', 'Lerato'],
      upsell: { name: 'Curl cream, 250 ml', price: 189 },
      services: [
        { id: 'cut', name: 'Cut & style', short: 'Cut', sub: '60 minutes', mins: 60, price: 450, cap: 1, perStaff: true, unit: ['appointment', 'appointments'], days: [2, 3, 4, 5, 6], times: ['09:00', '10:00', '11:00', '12:00', '14:00', '15:00', '16:00'] },
        { id: 'colour', name: 'Colour', short: 'Colour', sub: '2 hours · toner included', mins: 120, price: 1200, cap: 1, perStaff: true, unit: ['appointment', 'appointments'], days: [2, 3, 4, 5, 6], times: ['09:00', '11:00', '14:00'] },
        { id: 'braids', name: 'Knotless braids', short: 'Braids', sub: '3 hours · medium length', mins: 180, price: 950, cap: 1, perStaff: true, unit: ['appointment', 'appointments'], days: [3, 5, 6], times: ['09:00', '13:00'] }
      ]
    },
    padel: {
      name: 'Atlantic Padel', kind: 'Padel club', domain: 'atlanticpadel.co.za', deposit: { type: 'full' },
      upsell: { name: 'Ball tube (3 balls)', price: 120 },
      services: [
        { id: 'court', name: 'Court hire', short: 'Court', sub: '60 minutes · up to 4 players', mins: 60, price: 480, cap: 3, maxQty: 2, unit: ['court', 'courts'], days: [0, 1, 2, 3, 4, 5, 6], times: ['07:00', '08:00', '12:00', '17:00', '18:00', '19:00', '20:00'] },
        { id: 'clinic', name: 'Coaching clinic', short: 'Clinic', sub: '90 minutes · beginners', mins: 90, price: 250, cap: 8, unit: ['player', 'players'], days: [3, 6], times: ['09:00', '18:00'], names: 'Player name' }
      ]
    }
  };
  var NAMES = ['Thandi M.', 'Sipho K.', 'Lerato N.', 'Ayesha P.', 'Johan V.', 'Megan D.', 'Kabelo R.', 'Zanele T.', 'Pieter B.', 'Naledi S.', 'Ruan C.', 'Fatima A.', 'Liam O.', 'Busi H.', 'Chloe W.', 'Tumi L.', 'Imraan J.', 'Kayla F.', 'Musa Z.', 'Anika G.', 'Daniel E.', 'Precious M.', 'Yusuf I.', 'Mia R.'];
  var DAYS_AHEAD = 14;
  if (SITE && SITE.biz && SITE.biz.services && SITE.biz.services.length) { BIZ = {}; BIZ[SITE.id] = SITE.biz; KEY = 'bhuka-demo-site-' + SITE.id; }

  /* ---------------- state ---------------- */
  var FIRST = Object.keys(BIZ)[0];
  var fresh = function () { return { biz: FIRST, bookings: [], waitlist: [], over: {}, settings: {}, order: 1042 }; };
  var S = store.get();
  if (!S || !S.bookings || !S.over) S = fresh();
  if (!BIZ[S.biz]) S.biz = FIRST;
  var save = function () { store.set(S); };
  var ui = { screen: 'pick', svc: null, date: null, time: null, staff: 'any', qty: 1, names: [], upsell: false, cart: null, err: '', last: null, manage: null, tab: 'cal', week: 0, drawer: null, search: '', view: 'shop', toast: '', wa: null, badge: false, confirmCancel: null, reschedTo: '' };

  var B = function () { return BIZ[S.biz]; };
  var set = function () { var s = S.settings[S.biz]; if (!s) { s = S.settings[S.biz] = { deposit: null, caps: {}, wa: true, resched: true }; } return s; };
  var depRule = function () { return set().deposit || B().deposit; };
  var svcById = function (id, biz) { var list = (biz ? BIZ[biz] : B()).services; for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i]; return list[0]; };
  var capOf = function (svc) { var c = set().caps[svc.id]; return c != null ? c : svc.cap; };
  var unit = function (svc, n) { return n === 1 ? svc.unit[0] : svc.unit[1]; };
  var depositFor = function (total, qty) {
    var r = depRule();
    if (r.type === 'pct') return Math.round(total * r.value / 100);
    if (r.type === 'fixed') return Math.min(total, r.value * qty);
    return total;
  };
  var depLabel = function () { var r = depRule(); if (r.type === 'pct') return r.value + '% deposit today'; if (r.type === 'fixed') return money(r.value) + ' deposit today'; return 'Pay in full to book'; };

  /* sessions for a date */
  var slotsFor = function (svc, date) {
    var d = parse(date).getDay();
    if (svc.days.indexOf(d) === -1) return [];
    return svc.times.slice();
  };

  /* seeded (made-up) bookings for a slot, stable per day */
  var seedCache = {}, forcedCache = {};
  var forced = function (biz, svc) {
    var key = biz + '|' + svc.id;
    if (forcedCache[key] !== undefined) return forcedCache[key];
    var list = [];
    for (var i = 0; i < DAYS_AHEAD && list.length < 2; i++) {
      var ds = ymd(addDays(TODAY, i));
      slotsFor(svc, ds).forEach(function (t) { if (list.length < 2 && !isPast(ds, t)) list.push({ date: ds, time: t }); });
    }
    forcedCache[key] = list[1] || list[0] || null;
    return forcedCache[key];
  };
  var seeded = function (biz, svc, date, time) {
    var k = biz + '|' + svc.id + '|' + date + '|' + time;
    if (seedCache[k]) return seedCache[k];
    var out = [];
    var r = rnd(k);
    var ff = forced(biz, svc); var forceFull = !!(ff && ff.date === date && ff.time === time);
    if (svc.perStaff) {
      BIZ[biz].staff.forEach(function (st, i) {
        if (forceFull || rnd(k + st) < 0.42) out.push({ id: 's' + hash(k + st).toString(36), seed: true, biz: biz, svc: svc.id, date: date, time: time, qty: 1, staff: st, name: NAMES[hash(k + st) % NAMES.length], names: [] });
      });
    } else {
      var cap = svc.cap;
      var taken = r < 0.14 ? cap : Math.floor(cap * (0.25 + r * 0.6));
      if (cap === 1) taken = r < 0.45 ? 1 : 0;
      if (forceFull) taken = cap;
      var n = 0, j = 0;
      while (n < taken) {
        var q = Math.min(taken - n, 1 + (hash(k + j) % 3));
        if (svc.id === 'court') q = 1;
        out.push({ id: 's' + hash(k + 'b' + j).toString(36), seed: true, biz: biz, svc: svc.id, date: date, time: time, qty: q, name: NAMES[(hash(k + j) + j * 7) % NAMES.length], names: [] });
        n += q; j++;
      }
    }
    out.forEach(function (b) {
      var price = svc.price * b.qty;
      b.total = price; b.paid = depositForBiz(biz, price, b.qty); b.status = 'confirmed';
    });
    seedCache[k] = out;
    return out;
  };
  var depositForBiz = function (biz, total, qty) {
    var r = (S.settings[biz] && S.settings[biz].deposit) || BIZ[biz].deposit;
    if (r.type === 'pct') return Math.round(total * r.value / 100);
    if (r.type === 'fixed') return Math.min(total, r.value * qty);
    return total;
  };
  var statusOf = function (b) { return b.seed ? (S.over[b.id] && S.over[b.id].status) || b.status : b.status; };
  var slotOf = function (b) { return b.seed && S.over[b.id] && S.over[b.id].date ? S.over[b.id] : b; };
  var bookingsAt = function (svc, date, time) {
    var list = seeded(S.biz, svc, date, time).filter(function (b) { var s = slotOf(b); return s.date === date && s.time === time; });
    // seeded bookings moved here from elsewhere
    Object.keys(S.over).forEach(function (id) {
      var o = S.over[id];
      if (o.biz === S.biz && o.svc === svc.id && o.date === date && o.time === time && o.from && o.from !== date + '|' + time) {
        var orig = findSeed(id, o);
        if (orig && list.indexOf(orig) === -1) list.push(orig);
      }
    });
    S.bookings.forEach(function (b) { if (b.biz === S.biz && b.svc === svc.id && b.date === date && b.time === time) list.push(b); });
    return list;
  };
  var findSeed = function (id, o) {
    var parts = (o.from || '').split('|');
    var svc = svcById(o.svc, o.biz);
    var src = seeded(o.biz, svc, parts[0], parts[1]);
    for (var i = 0; i < src.length; i++) if (src[i].id === id) return src[i];
    return null;
  };
  var staffOf = function (b) { return (b.seed && S.over[b.id] && S.over[b.id].staff) || b.staff; };
  var active = function (b) { var s = statusOf(b); return s !== 'cancelled'; };
  var avail = function (svc, date, time) {
    var list = bookingsAt(svc, date, time).filter(active);
    if (svc.perStaff) {
      var busy = list.map(staffOf);
      var free = B().staff.filter(function (s) { return busy.indexOf(s) === -1; });
      return { left: free.length, cap: B().staff.length, taken: busy.length, free: free, list: list };
    }
    var taken = list.reduce(function (a, b) { return a + b.qty; }, 0);
    var cap = capOf(svc);
    return { left: Math.max(0, cap - taken), cap: cap, taken: taken, list: list };
  };
  var waitFor = function (svc, date, time) { return S.waitlist.filter(function (w) { return w.biz === S.biz && w.svc === svc.id && w.date === date && w.time === time && w.status !== 'booked' && w.status !== 'removed'; }); };

  var dates = function () { var out = []; for (var i = 0; i < DAYS_AHEAD; i++) out.push(ymd(addDays(TODAY, i))); return out; };
  var firstOpen = function (svc) {
    var ds = dates();
    for (var i = 0; i < ds.length; i++) {
      var ts = slotsFor(svc, ds[i]);
      for (var j = 0; j < ts.length; j++) if (!isPast(ds[i], ts[j]) && avail(svc, ds[i], ts[j]).left > 0) return { date: ds[i], time: ts[j] };
    }
    for (var x = 0; x < ds.length; x++) { if (slotsFor(svc, ds[x]).length) return { date: ds[x], time: null }; }
    return { date: ds[0], time: null };
  };
  var resetPick = function (svcId) {
    var svc = svcId ? svcById(svcId) : B().services[0];
    var f = firstOpen(svc);
    ui.svc = svc.id; ui.date = f.date; ui.time = f.time; ui.staff = 'any'; ui.qty = 1; ui.names = []; ui.err = '';
  };

  /* ---------------- toast + WhatsApp ---------------- */
  var toastTimer;
  var adminToast = function (msg) {
    ui.toast = msg; ui.badge = ui.view === 'shop';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { ui.toast = ''; var t = adminEl.querySelector('.bd-toast'); if (t) t.remove(); }, 4200);
  };
  var waMsg = function (b, kind) {
    var svc = svcById(b.svc, b.biz); var first = (b.name || 'there').split(' ')[0];
    var when = dayLong(b.date) + ' at ' + b.time;
    var q = b.qty + ' ' + unit(svc, b.qty);
    if (kind === 'wait') return 'Hi ' + first + ', you’re on the waitlist for ' + svc.name + ', ' + when + '. We’ll WhatsApp you the moment a ' + svc.unit[0] + ' opens. ' + BIZ[b.biz].name;
    if (kind === 'offer') return 'Hi ' + first + ', a ' + svc.unit[0] + ' just opened for ' + svc.name + ', ' + when + '. Tap to claim it in the next 2 hours. ' + BIZ[b.biz].name;
    if (kind === 'move') return 'Hi ' + first + ', your ' + svc.name + ' booking has moved to ' + when + '. Nothing else to do. ' + BIZ[b.biz].name;
    if (kind === 'cancel') return 'Hi ' + first + ', your ' + svc.name + ' booking on ' + when + ' is cancelled and ' + money(b.paid) + ' is on its way back to your card. ' + BIZ[b.biz].name;
    var bal = b.total - b.paid;
    return 'Hi ' + first + ', you’re booked: ' + svc.name + (b.staff ? ' with ' + b.staff : '') + ', ' + when + ' · ' + q + '. ' + (b.total === 0 ? 'Nothing to pay' : b.paid ? money(b.paid) + ' paid' : 'Nothing paid yet') + (bal > 0 ? ', ' + money(bal) + ' due on the day.' : '.') + ' Need to move it? Reply MOVE. ' + BIZ[b.biz].name;
  };

  var waTimer;
  var showWa = function (text, claim, force) {
    ui.wa = (set().wa || force) ? { text: text, claim: claim || null } : null;
    clearTimeout(waTimer);
    if (ui.wa && !ui.wa.claim) {
      var mine = ui.wa;
      waTimer = setTimeout(function () {
        if (ui.wa !== mine) return;
        ui.wa = null;
        var el = shopEl.querySelector('.bd-wa'); if (el) el.remove();
        var st = shopEl.querySelector('.bd-store'); if (st) st.classList.remove('has-wa');
      }, 9000);
    }
  };

  /* ---------------- customer view ---------------- */
  var renderShop = function () {
    var biz = B(); var svc = svcById(ui.svc);
    var cartCount = ui.cart ? 1 + (ui.upsell ? 1 : 0) : 0;
    var path = ui.screen === 'checkout' ? 'checkouts/demo' : ui.screen === 'cart' ? 'cart' : ui.screen === 'done' || ui.screen === 'waitdone' ? 'orders/thank-you' : ui.screen === 'manage' ? 'apps/bhuka/manage' : 'products/' + svc.id;
    var h = '<div class="bd-browser' + (SITE ? ' bd-browser--site' : '') + '">' +
      (SITE ? '' : '<div class="bd-browser__bar"><span class="bd-dots"><i></i><i></i><i></i></span><span class="bd-url">' + ICON.lock + esc(biz.domain + '/' + path) + '</span></div>') +
      '<div class="bd-store' + (ui.wa && ui.wa.text ? ' has-wa' : '') + '"><header class="bd-store__top">' + (SITE ? '<b class="bd-store__logo">Book online</b><span class="bd-store__kind">' + esc(biz.name) + '</span>' : '<b class="bd-store__logo">' + esc(biz.name) + '</b><span class="bd-store__kind">' + esc(biz.kind) + '</span>') +
      '<button type="button" class="bd-cartbtn" data-act="go" data-v="cart" aria-label="Cart, ' + cartCount + ' items">' + ICON.bag + (cartCount ? '<i>' + cartCount + '</i>' : '') + '</button></header>' +
      '<div class="bd-screen" data-bd-screen>' + screenHtml(svc) + '</div></div></div>';
    if (ui.wa && ui.wa.text) {
      h += '<div class="bd-wa" role="status"><div class="bd-wa__head"><i>' + ICON.chat + '</i>' + (set().wa ? 'WhatsApp' : 'Email') + ' to you · just now<button type="button" data-act="wa-close" aria-label="Close message">' + ICON.close + '</button></div><p>' + esc(ui.wa.text) + '</p>' +
        (ui.wa.claim ? '<button type="button" class="bd-wa__btn" data-act="claim" data-v="' + ui.wa.claim + '">Claim it</button>' : '') + '</div>';
    }
    shopEl.innerHTML = h;
  };

  var screenHtml = function (svc) {
    if (ui.screen === 'cart') return cartHtml();
    if (ui.screen === 'checkout') return checkoutHtml();
    if (ui.screen === 'done') return doneHtml();
    if (ui.screen === 'waitdone') return waitDoneHtml();
    if (ui.screen === 'waitform') return waitFormHtml(svc);
    if (ui.screen === 'manage') return manageHtml();
    return pickHtml(svc);
  };

  var pickHtml = function (svc) {
    var biz = B();
    var h = '<div class="bd-svcs" role="tablist" aria-label="Services">';
    biz.services.forEach(function (s) { h += '<button type="button" role="tab" data-act="svc" data-v="' + s.id + '" aria-selected="' + (s.id === svc.id) + '">' + esc(s.short) + '</button>'; });
    h += '</div>';
    h += '<h3 class="bd-h">' + esc(svc.name) + '</h3><p class="bd-sub">' + esc(svc.sub) + '</p>';
    h += svc.price === 0 ? '<div class="bd-price"><b>Free</b><span>' + esc(svc.mins) + ' minutes</span><em>No payment needed</em></div>' : '<div class="bd-price"><b>' + money(svc.price) + '</b><span>/ ' + esc(svc.unit[0]) + '</span><em>' + esc(depLabel()) + '</em></div>';
    // dates
    h += '<div class="bd-label">Choose a day</div><div class="bd-dates" role="group" aria-label="Days">';
    dates().forEach(function (ds) {
      var d = parse(ds); var ts = slotsFor(svc, ds); var open = 0, any = ts.length > 0;
      ts.forEach(function (t) { if (!isPast(ds, t)) { var a = avail(svc, ds, t); if (a.left > 0) open++; } });
      var cls = !any ? 'none' : open === 0 ? 'full' : open < ts.length ? 'few' : 'ok';
      h += '<button type="button" data-act="date" data-v="' + ds + '" aria-pressed="' + (ds === ui.date) + '"' + (!any ? ' class="is-off"' : '') + ' aria-label="' + esc(dayLong(ds)) + (any ? '' : ', closed') + '"><small>' + (ds === TODAY_S ? 'Today' : DAYN[d.getDay()]) + '</small><b>' + d.getDate() + '</b><i class="bd-dot bd-dot--' + cls + '"></i></button>';
    });
    h += '</div>';
    var ts = slotsFor(svc, ui.date);
    if (biz.staff) {
      h += '<div class="bd-label">' + esc(biz.staffLabel || 'Who with?') + '</div><div class="bd-chips" role="group" aria-label="' + esc(biz.staffLabel || 'Who with') + '">';
      ['any'].concat(biz.staff).forEach(function (st) { h += '<button type="button" data-act="staff" data-v="' + st + '" aria-pressed="' + (ui.staff === st) + '">' + (st === 'any' ? 'Anyone' : esc(st)) + '</button>'; });
      h += '</div>';
    }
    h += '<div class="bd-label">Choose a time <span>' + esc(dayLong(ui.date)) + '</span></div>';
    if (!ts.length) {
      var nx = firstOpen(svc);
      h += '<div class="bd-empty">No ' + esc(svc.short.toLowerCase()) + ' on this day. <button type="button" class="bd-link" data-act="date" data-v="' + nx.date + '">Next one: ' + esc(dayLabel(nx.date)) + '</button></div>';
    } else {
      h += '<div class="bd-times" role="group" aria-label="Times">';
      ts.forEach(function (t) {
        var past = isPast(ui.date, t); var a = avail(svc, ui.date, t);
        var left = a.left;
        if (biz.staff && ui.staff !== 'any') left = a.free.indexOf(ui.staff) === -1 ? 0 : 1;
        var label = past ? 'Closed' : left === 0 ? 'Waitlist' : svc.perStaff ? (ui.staff === 'any' ? left + ' free' : 'Free') : left <= 3 ? left + ' left' : left + ' ' + unit(svc, left) + ' left';
        if (!past && left > 0 && !svc.perStaff && svc.cap === 1) label = 'Free';
        h += '<button type="button" data-act="time" data-v="' + t + '" aria-pressed="' + (ui.time === t) + '"' + (past ? ' disabled' : '') + ' class="' + (left === 0 && !past ? 'is-full' : '') + '"><b>' + t + '</b><em>' + label + '</em></button>';
      });
      h += '</div>';
    }
    if (ui.time && slotsFor(svc, ui.date).indexOf(ui.time) !== -1 && !isPast(ui.date, ui.time)) {
      var a2 = avail(svc, ui.date, ui.time);
      var left2 = biz.staff && ui.staff !== 'any' ? (a2.free.indexOf(ui.staff) === -1 ? 0 : 1) : a2.left;
      if (left2 === 0) {
        h += '<div class="bd-note bd-note--pink"><b>This time is full.</b> Join the waitlist and we’ll WhatsApp you the moment a ' + esc(svc.unit[0]) + ' opens. ' + (waitFor(svc, ui.date, ui.time).length ? waitFor(svc, ui.date, ui.time).length + ' already waiting.' : '') + '</div>';
        h += '<button type="button" class="bd-cta bd-cta--ink" data-act="waitlist">Join the waitlist</button>';
      } else {
        var maxQ = Math.min(svc.maxQty || 6, left2, svc.perStaff ? 1 : 99);
        ui.qty = Math.max(1, Math.min(ui.qty, maxQ));
        if (maxQ > 1) {
          h += '<div class="bd-qty"><span>How many ' + esc(svc.unit[1]) + '?</span><span class="bd-step"><button type="button" data-act="qty" data-v="-1" aria-label="One less"' + (ui.qty <= 1 ? ' disabled' : '') + '>−</button><output aria-live="polite">' + ui.qty + '</output><button type="button" data-act="qty" data-v="1" aria-label="One more"' + (ui.qty >= maxQ ? ' disabled' : '') + '>+</button></span></div>';
        }
        if (svc.names) {
          h += '<div class="bd-names">';
          for (var i = 0; i < ui.qty; i++) h += '<input type="text" data-in="name" data-i="' + i + '" value="' + esc(ui.names[i] || '') + '" placeholder="' + esc(svc.names + (ui.qty > 1 ? ' ' + (i + 1) : '')) + ' (optional)" autocomplete="off">';
          h += '</div>';
        }
        var total = svc.price * ui.qty; var dep = depositFor(total, ui.qty);
        if (total > 0) h += '<div class="bd-sum"><div><span>' + ui.qty + ' ' + esc(unit(svc, ui.qty)) + ' × ' + money(svc.price) + '</span><b>' + money(total) + '</b></div>' +
          '<div><span>Pay today</span><b>' + money(dep) + '</b></div>' + (total - dep > 0 ? '<div><span>Balance on the day</span><b>' + money(total - dep) + '</b></div>' : '') + '</div>';
        if (ui.err) h += '<p class="bd-err" role="alert">' + esc(ui.err) + '</p>';
        h += '<button type="button" class="bd-cta" data-act="add">' + (total === 0 ? 'Reserve it · free' : 'Add to cart · ' + money(dep) + ' today') + '</button>';
      }
    } else if (ts.length) {
      h += '<div class="bd-hint">Pick a time to continue.</div>';
    }
    h += '<p class="bd-small">Demo store. Nothing is charged.</p>';
    return h;
  };

  var cartHtml = function () {
    if (!ui.cart) return '<h3 class="bd-h">Your cart</h3><p class="bd-sub">Your cart is empty.</p><button type="button" class="bd-cta" data-act="go" data-v="pick">Book something</button>';
    var c = ui.cart; var svc = svcById(c.svc); var up = B().upsell;
    var h = '<div class="bd-back"><button type="button" class="bd-link" data-act="go" data-v="pick">' + ICON.left + 'Keep browsing</button></div><h3 class="bd-h">Your cart</h3>';
    h += '<div class="bd-line"><div class="bd-line__ico">' + ICON.cal + '</div><div class="bd-line__txt"><b>' + esc(svc.name) + '</b><span>' + esc(dayLong(c.date)) + ' · ' + c.time + (c.staff ? ' · with ' + esc(c.staff) : '') + '</span><span>' + c.qty + ' ' + esc(unit(svc, c.qty)) + (c.names.filter(Boolean).length ? ' · ' + esc(c.names.filter(Boolean).join(', ')) : '') + '</span></div><b>' + money(c.total) + '</b></div>';
    h += '<label class="bd-upsell"><input type="checkbox" data-act="upsell"' + (ui.upsell ? ' checked' : '') + '><span><b>Add ' + esc(up.name) + '</b><small>Products and bookings check out together.</small></span><em>' + money(up.price) + '</em></label>';
    var dueToday = c.paid + (ui.upsell ? up.price : 0); var sub = c.total + (ui.upsell ? up.price : 0);
    h += '<div class="bd-sum"><div><span>Subtotal</span><b>' + money(sub) + '</b></div><div><span>Due today</span><b>' + money(dueToday) + '</b></div>' + (c.total - c.paid > 0 ? '<div><span>Balance on the day</span><b>' + money(c.total - c.paid) + '</b></div>' : '') + '</div>';
    h += '<button type="button" class="bd-cta" data-act="go" data-v="checkout">Check out</button>';
    h += '<button type="button" class="bd-link bd-link--center" data-act="remove">Remove booking</button>';
    return h;
  };

  var checkoutHtml = function () {
    var c = ui.cart; if (!c) return cartHtml();
    var up = B().upsell; var due = c.paid + (ui.upsell ? up.price : 0);
    var h = '<div class="bd-back"><button type="button" class="bd-link" data-act="go" data-v="cart">' + ICON.left + 'Back to cart</button></div>';
    h += '<div class="bd-co"><div class="bd-co__brand">' + esc(B().name) + ' <span>Checkout</span></div>';
    h += '<div class="bd-label">Contact</div><div class="bd-fields">' +
      '<input type="text" data-in="cname" value="' + esc(ui.cname || '') + '" placeholder="Your name" autocomplete="off" aria-label="Your name">' +
      '<input type="tel" data-in="cphone" value="' + esc(ui.cphone || '') + '" placeholder="WhatsApp number (optional)" autocomplete="off" aria-label="WhatsApp number">' +
      '</div>' + (ui.err ? '<p class="bd-err" role="alert">' + esc(ui.err) + '</p>' : '');
    h += '<div class="bd-label">Payment</div><div class="bd-pay"><span class="bd-pay__card">VISA</span><span>Demo card •••• 4242</span><em>No real payment</em></div>';
    h += '<div class="bd-sum"><div><span>' + esc(svcById(c.svc).name) + '</span><b>' + money(c.paid) + '</b></div>' + (ui.upsell ? '<div><span>' + esc(up.name) + '</span><b>' + money(up.price) + '</b></div>' : '') + '<div class="bd-sum__total"><span>Pay now</span><b>' + money(due) + '</b></div></div>';
    h += '<button type="button" class="bd-cta" data-act="pay"' + (ui.paying ? ' disabled' : '') + '>' + (ui.paying ? 'Processing…' : due === 0 ? 'Confirm booking' : 'Pay ' + money(due)) + '</button></div>';
    return h;
  };

  var findBooking = function (id) {
    for (var i = 0; i < S.bookings.length; i++) if (S.bookings[i].id === id) return S.bookings[i];
    return null;
  };

  var doneHtml = function () {
    var b = findBooking(ui.last); if (!b) return pickHtml(svcById(ui.svc));
    var svc = svcById(b.svc, b.biz);
    var h = '<div class="bd-done"><span class="bd-done__tick">' + ICON.check + '</span><h3 class="bd-h">You’re booked, ' + esc(b.name.split(' ')[0]) + '.</h3><p class="bd-sub">Order #' + b.order + ' · confirmation sent on WhatsApp and email.</p></div>';
    h += bookingCard(b, svc);
    h += '<div class="bd-row2"><button type="button" class="bd-btn" data-act="ics" data-v="' + b.id + '">' + ICON.cal + 'Add to calendar</button><button type="button" class="bd-btn" data-act="manage" data-v="' + b.id + '">Manage booking</button></div>';
    h += '<button type="button" class="bd-cta bd-cta--ink" data-act="again">Book something else</button>';
    h += '<button type="button" class="bd-link bd-link--center bd-only-m" data-act="view" data-v="admin">See it in the admin ' + ICON.right + '</button>';
    return h;
  };
  var bookingCard = function (b, svc) {
    var st = statusOf(b);
    return '<div class="bd-card"><div><span>What</span><b>' + esc(svc.name) + (b.staff ? ' · ' + esc(b.staff) : '') + '</b></div>' +
      '<div><span>When</span><b>' + esc(dayLong(b.date)) + ' · ' + b.time + '</b></div>' +
      '<div><span>' + esc(svc.unit[1].charAt(0).toUpperCase() + svc.unit[1].slice(1)) + '</span><b>' + b.qty + (b.names && b.names.filter(Boolean).length ? ' · ' + esc(b.names.filter(Boolean).join(', ')) : '') + '</b></div>' +
      '<div><span>Paid</span><b>' + (b.total === 0 ? 'Free' : money(b.paid) + (b.total - b.paid > 0 && st !== 'cancelled' ? ' · ' + money(b.total - b.paid) + ' on the day' : '')) + '</b></div>' +
      (st !== 'confirmed' ? '<div><span>Status</span><b class="bd-st bd-st--' + st + '">' + statusText(st) + '</b></div>' : '') + '</div>';
  };
  var statusText = function (s) { return { confirmed: 'Confirmed', attended: 'Checked in', cancelled: 'Cancelled · refunded', noshow: 'No-show' }[s] || s; };

  var waitFormHtml = function (svc) {
    var h = '<div class="bd-back"><button type="button" class="bd-link" data-act="go" data-v="pick">' + ICON.left + 'Back</button></div>';
    h += '<h3 class="bd-h">Join the waitlist</h3><p class="bd-sub">' + esc(svc.name) + ' · ' + esc(dayLong(ui.date)) + ' · ' + ui.time + (ui.staff !== 'any' ? ' · ' + esc(ui.staff) : '') + '</p>';
    h += '<div class="bd-fields"><input type="text" data-in="cname" value="' + esc(ui.cname || '') + '" placeholder="Your name" autocomplete="off" aria-label="Your name"><input type="tel" data-in="cphone" value="' + esc(ui.cphone || '') + '" placeholder="WhatsApp number (optional)" autocomplete="off" aria-label="WhatsApp number"></div>' + (ui.err ? '<p class="bd-err" role="alert">' + esc(ui.err) + '</p>' : '');
    h += '<div class="bd-note">No payment now. When a ' + esc(svc.unit[0]) + ' opens, you get a WhatsApp with a link to claim it.</div>';
    h += '<button type="button" class="bd-cta bd-cta--ink" data-act="joinwait">Join the waitlist</button>';
    return h;
  };
  var waitDoneHtml = function () {
    var w = null; for (var i = 0; i < S.waitlist.length; i++) if (S.waitlist[i].id === ui.last) w = S.waitlist[i];
    if (!w) return pickHtml(svcById(ui.svc));
    var svc = svcById(w.svc, w.biz); var pos = S.waitlist.filter(function (x) { return x.biz === w.biz && x.svc === w.svc && x.date === w.date && x.time === w.time && x.status === 'waiting'; }).indexOf(w) + 1;
    var h = '<div class="bd-done"><span class="bd-done__tick bd-done__tick--ink">' + ICON.check + '</span><h3 class="bd-h">You’re on the list' + (pos > 0 ? ', #' + pos : '') + '.</h3><p class="bd-sub">' + esc(svc.name) + ' · ' + esc(dayLong(w.date)) + ' · ' + w.time + '</p></div>';
    h += '<div class="bd-note">Try it: open the admin, cancel a booking in this session, and watch Bhuka offer the ' + esc(svc.unit[0]) + ' to you.</div>';
    h += '<button type="button" class="bd-cta bd-cta--ink" data-act="again">Book something else</button>';
    h += '<button type="button" class="bd-link bd-link--center bd-only-m" data-act="view" data-v="admin">Open the admin ' + ICON.right + '</button>';
    return h;
  };
  var manageHtml = function () {
    var b = findBooking(ui.manage); if (!b) return pickHtml(svcById(ui.svc));
    var svc = svcById(b.svc, b.biz); var st = statusOf(b);
    var h = '<div class="bd-back"><button type="button" class="bd-link" data-act="go" data-v="' + (ui.last === b.id ? 'done' : 'pick') + '">' + ICON.left + 'Back</button></div>';
    h += '<h3 class="bd-h">Your booking</h3><p class="bd-sub">Order #' + b.order + '</p>' + bookingCard(b, svc);
    if (st === 'confirmed') {
      if (set().resched) {
        var alts = altSlots(b).slice(0, 6);
        h += '<div class="bd-label">Move it to</div>';
        if (alts.length) {
          h += '<div class="bd-times bd-times--alt" role="group" aria-label="Other times">';
          alts.forEach(function (a) { h += '<button type="button" data-act="cmove" data-v="' + a.date + '|' + a.time + '"><b>' + a.time + '</b><em>' + esc(dayLabel(a.date)) + '</em></button>'; });
          h += '</div>';
        } else h += '<p class="bd-sub">No other times with space right now.</p>';
      } else {
        h += '<div class="bd-note">Online rescheduling is switched off for this business. Reply on WhatsApp and the team will move it for you.</div>';
      }
      h += ui.confirmCancel === b.id ? '<button type="button" class="bd-cta bd-cta--danger" data-act="ccancel-yes" data-v="' + b.id + '">Yes, cancel and refund ' + money(b.paid) + '</button><button type="button" class="bd-link bd-link--center" data-act="ccancel-no">Keep my booking</button>'
        : '<button type="button" class="bd-link bd-link--center bd-link--danger" data-act="ccancel" data-v="' + b.id + '">Cancel booking</button>';
    }
    return h;
  };
  var altSlots = function (b) {
    var svc = svcById(b.svc, b.biz); var out = [];
    dates().forEach(function (ds) {
      slotsFor(svc, ds).forEach(function (t) {
        if (ds === b.date && t === b.time) return;
        if (isPast(ds, t)) return;
        var a = avail(svc, ds, t);
        if (svc.perStaff ? a.free.indexOf(b.staff) !== -1 || a.left > 0 : a.left >= b.qty) out.push({ date: ds, time: t });
      });
    });
    return out;
  };

  /* ---------------- admin view ---------------- */
  var weekDays = function () { var out = []; for (var i = 0; i < 7; i++) out.push(ymd(addDays(TODAY, ui.week * 7 + i))); return out; };
  var allIn = function (days) {
    var out = [];
    B().services.forEach(function (svc) {
      days.forEach(function (ds) { slotsFor(svc, ds).forEach(function (t) { bookingsAt(svc, ds, t).forEach(function (b) { out.push(b); }); }); });
    });
    // user bookings whose slot isn't a normal session (none expected) are already included
    return out;
  };
  var kpis = function () {
    var days = []; for (var i = 0; i < 7; i++) days.push(ymd(addDays(TODAY, i)));
    var list = allIn(days); var live = list.filter(active);
    var cap = 0, taken = 0;
    B().services.forEach(function (svc) { days.forEach(function (ds) { slotsFor(svc, ds).forEach(function (t) { var a = avail(svc, ds, t); cap += a.cap; taken += a.taken; }); }); });
    var paid = live.reduce(function (a, b) { return a + b.paid; }, 0);
    var waiting = S.waitlist.filter(function (w) { return w.biz === S.biz && (w.status === 'waiting' || w.status === 'offered'); }).length;
    return { bookings: live.length, fill: cap ? Math.round(taken / cap * 100) : 0, paid: paid, waiting: waiting };
  };

  var renderAdmin = function () {
    var k = kpis();
    var myCount = S.bookings.filter(function (b) { return b.biz === S.biz; }).length;
    var wCount = S.waitlist.filter(function (w) { return w.biz === S.biz && (w.status === 'waiting' || w.status === 'offered'); }).length;
    var h = '<div class="bd-adm">' +
      '<div class="bd-adm__bar"><span class="bd-adm__logo"><span class="bd-adm__icon">' + ICON.cal + '</span><b>bhuka</b></span><span class="bd-adm__biz">' + esc(B().name) + '</span><span class="bd-adm__live">Live</span>' +
      '<button type="button" class="bd-adm__reset" data-act="reset">Reset demo</button></div>' +
      '<div class="bd-kpis">' +
      '<div><b>' + k.bookings + '</b><span>Bookings · 7 days</span></div>' +
      '<div><b>' + k.fill + '%</b><span>Full</span></div>' +
      '<div><b>' + money(k.paid) + '</b><span>Taken upfront</span></div>' +
      '<div><b>' + k.waiting + '</b><span>On waitlists</span></div></div>' +
      '<div class="bd-tabs" role="tablist" aria-label="Admin sections">' +
      tabBtn('cal', 'Calendar') + tabBtn('list', 'Bookings' + (myCount ? ' <i>' + myCount + '</i>' : '')) + tabBtn('wait', 'Waitlist' + (wCount ? ' <i>' + wCount + '</i>' : '')) + tabBtn('set', 'Settings') + '</div>' +
      '<div class="bd-adm__body">' + adminBody() + '</div>';
    if (ui.drawer) h += '<div class="bd-drawer" role="dialog" aria-label="Details">' + drawerHtml() + '</div>';
    if (ui.toast) h += '<div class="bd-toast" role="status">' + ICON.check + '<span>' + esc(ui.toast) + '</span></div>';
    h += '</div>';
    adminEl.innerHTML = h;
    var badge = root.querySelector('[data-bd-badge]');
    if (badge) badge.hidden = !ui.badge;
  };
  var tabBtn = function (id, label) { return '<button type="button" role="tab" data-act="tab" data-v="' + id + '" aria-selected="' + (ui.tab === id) + '">' + label + '</button>'; };

  var adminBody = function () {
    if (ui.tab === 'list') return listHtml();
    if (ui.tab === 'wait') return waitHtml();
    if (ui.tab === 'set') return settingsHtml();
    return calHtml();
  };

  var calHtml = function () {
    var days = weekDays(); var biz = B();
    var h = '<div class="bd-calbar"><b>' + (ui.week === 0 ? 'This week' : 'Next week') + '</b><span class="bd-calnav"><button type="button" data-act="week" data-v="0" aria-label="This week"' + (ui.week === 0 ? ' disabled' : '') + '>' + ICON.left + '</button><button type="button" data-act="week" data-v="1" aria-label="Next week"' + (ui.week === 1 ? ' disabled' : '') + '>' + ICON.right + '</button></span></div>';
    h += '<div class="bd-week">';
    days.forEach(function (ds) {
      var d = parse(ds);
      h += '<div class="bd-dayc' + (ds === TODAY_S ? ' is-today' : '') + '"><div class="bd-dayc__head"><small>' + DAYN[d.getDay()] + '</small><b>' + d.getDate() + '</b></div><div class="bd-dayc__evs">';
      var evs = [];
      biz.services.forEach(function (svc) {
        slotsFor(svc, ds).forEach(function (t) {
          var a = avail(svc, ds, t);
          if (svc.perStaff && !a.list.length) return;
          var mine = a.list.some(function (b) { return !b.seed; });
          evs.push({ svc: svc, t: t, a: a, mine: mine });
        });
      });
      evs.sort(function (x, y) { return mins(x.t) - mins(y.t); });
      if (!evs.length) h += '<span class="bd-dayc__none">Closed</span>';
      var shown = evs;
      var maxEv = SITE ? 7 : 4;
      if (biz.staff && evs.length > maxEv) {
        var mineE = evs.filter(function (e) { return e.mine; });
        shown = mineE.concat(evs.filter(function (e) { return !e.mine; }).slice(0, Math.max(0, maxEv - mineE.length)));
        shown.sort(function (x, y) { return mins(x.t) - mins(y.t); });
      }
      shown.forEach(function (e) {
        var full = e.a.left === 0; var ratio = e.a.cap ? e.a.taken / e.a.cap : 0;
        var cls = full ? 'ink' : ratio >= 0.5 ? 'pink' : 'sand';
        if (isPast(ds, e.t)) cls += ' is-past';
        var meta = e.svc.perStaff ? e.a.taken + '/' + e.a.cap + ' ' + (biz.staffNoun || 'chairs') : full ? 'Full' : e.a.taken + '/' + e.a.cap;
        h += '<button type="button" class="bd-ev bd-ev--' + cls + (e.mine ? ' is-mine' : '') + '" data-act="session" data-v="' + e.svc.id + '|' + ds + '|' + e.t + '"><b>' + e.t + '</b><span>' + esc(e.svc.short) + '</span><em>' + meta + '</em></button>';
      });
      if (evs.length > shown.length) h += '<button type="button" class="bd-ev bd-ev--more" data-act="day" data-v="' + ds + '">+' + (evs.length - shown.length) + ' more</button>';
      h += '</div></div>';
    });
    h += '</div><p class="bd-legend"><i class="bd-ev--sand"></i>Space <i class="bd-ev--pink"></i>Filling up <i class="bd-ev--ink"></i>Full <i class="bd-mine"></i>Your booking</p>';
    return h;
  };

  var rowHtml = function (b) {
    var svc = svcById(b.svc, b.biz); var sl = slotOf(b); var st = statusOf(b);
    return '<button type="button" class="bd-rowb' + (!b.seed ? ' is-mine' : '') + '" data-act="booking" data-v="' + b.id + '">' +
      '<span class="bd-rowb__when"><b>' + sl.time + '</b><small>' + esc(dayLabel(sl.date)) + '</small></span>' +
      '<span class="bd-rowb__who"><b>' + esc(b.name) + (!b.seed ? ' <i>New</i>' : '') + '</b><small>' + esc(svc.short) + (b.staff ? ' · ' + esc(b.staff) : '') + ' · ' + b.qty + ' ' + esc(unit(svc, b.qty)) + '</small></span>' +
      '<span class="bd-st bd-st--' + st + '">' + statusText(st).split(' · ')[0] + '</span></button>';
  };
  var listHtml = function () {
    var days = []; for (var i = 0; i < 7; i++) days.push(ymd(addDays(TODAY, i)));
    var mine = S.bookings.filter(function (b) { return b.biz === S.biz; }).slice().reverse();
    var seeds = allIn(days).filter(function (b) { return b.seed; });
    seeds.sort(function (x, y) { var a = slotOf(x), b = slotOf(y); return a.date === b.date ? mins(a.time) - mins(b.time) : a.date < b.date ? -1 : 1; });
    var q = (ui.search || '').toLowerCase();
    var match = function (b) { return !q || (b.name + ' ' + svcById(b.svc, b.biz).name + ' ' + (b.staff || '')).toLowerCase().indexOf(q) !== -1; };
    var h = '<div class="bd-search">' + ICON.search + '<input type="search" data-in="search" value="' + esc(ui.search) + '" placeholder="Search bookings by name or service" aria-label="Search bookings"></div><div data-bd-list>';
    h += listRows(mine.filter(match), seeds.filter(match));
    return h + '</div>';
  };
  var listRows = function (mine, seeds) {
    var h = '';
    if (mine.length) { h += '<div class="bd-group">Made in this demo</div>'; mine.forEach(function (b) { h += rowHtml(b); }); }
    h += '<div class="bd-group">Next 7 days</div>';
    if (!seeds.length) h += '<p class="bd-emptyrow">No bookings match.</p>';
    seeds.slice(0, 30).forEach(function (b) { h += rowHtml(b); });
    if (seeds.length > 30) h += '<p class="bd-emptyrow">+' + (seeds.length - 30) + ' more this week</p>';
    return h;
  };

  var waitHtml = function () {
    var list = S.waitlist.filter(function (w) { return w.biz === S.biz && w.status !== 'removed'; });
    if (!list.length) return '<div class="bd-emptybox"><b>No one is waiting.</b><p>Book a full time on the customer side (it says “Waitlist”) and join the list. Then cancel a booking in that session here and Bhuka offers the space automatically.</p></div>';
    var h = '';
    list.slice().reverse().forEach(function (w) {
      var svc = svcById(w.svc, w.biz); var a = avail(svc, w.date, w.time);
      var hasRoom = svc.perStaff ? (w.staff && w.staff !== 'any' ? a.free.indexOf(w.staff) !== -1 : a.left > 0) : a.left >= w.qty;
      h += '<div class="bd-wrow"><div><b>' + esc(w.name) + '</b><small>' + esc(svc.short) + ' · ' + esc(dayLabel(w.date)) + ' ' + w.time + ' · ' + w.qty + ' ' + esc(unit(svc, w.qty)) + '</small></div>';
      if (w.status === 'waiting') h += hasRoom ? '<button type="button" class="bd-mini bd-mini--red" data-act="offer" data-v="' + w.id + '">Offer the space</button>' : '<span class="bd-st bd-st--wait">Waiting</span>';
      else if (w.status === 'offered') h += '<span class="bd-wrow__acts"><span class="bd-st bd-st--offer">Offered</span><button type="button" class="bd-mini" data-act="claim" data-v="' + w.id + '">They claimed it</button></span>';
      else h += '<span class="bd-st bd-st--attended">Booked</span>';
      h += '</div>';
    });
    return h;
  };

  var settingsHtml = function () {
    var r = depRule(); var cur = r.type === 'pct' ? 'pct' : r.type === 'fixed' ? 'fixed' : 'full';
    var opts = [['full', 'Pay in full'], ['pct', '50% deposit'], ['fixed', 'R200 deposit']];
    var h = '<div class="bd-set"><div class="bd-set__row"><div><b>Payment at booking</b><small>Charged through your own Shopify checkout.</small></div><div class="bd-seg" role="group" aria-label="Payment at booking">';
    opts.forEach(function (o) { h += '<button type="button" data-act="dep" data-v="' + o[0] + '" aria-pressed="' + (cur === o[0]) + '">' + o[1] + '</button>'; });
    h += '</div></div>';
    B().services.forEach(function (svc) {
      if (svc.perStaff || svc.cap === 1) return;
      var c = capOf(svc);
      h += '<div class="bd-set__row"><div><b>' + esc(svc.name) + '</b><small>' + esc(svc.unit[1].charAt(0).toUpperCase() + svc.unit[1].slice(1)) + ' per session</small></div><span class="bd-step"><button type="button" data-act="cap" data-v="' + svc.id + '|-1" aria-label="Fewer"' + (c <= 1 ? ' disabled' : '') + '>−</button><output>' + c + '</output><button type="button" data-act="cap" data-v="' + svc.id + '|1" aria-label="More"' + (c >= 40 ? ' disabled' : '') + '>+</button></span></div>';
    });
    h += toggleRow('wa', 'WhatsApp confirmations', 'Booking, reminder, waitlist and change messages.');
    h += toggleRow('resched', 'Customers can reschedule', 'From their confirmation link, up to 24 hours before.');
    h += '<p class="bd-small">Change something here, then look at the customer side. It updates straight away.</p></div>';
    return h;
  };
  var toggleRow = function (k, t, sub) { var on = !!set()[k]; return '<div class="bd-set__row"><div><b>' + t + '</b><small>' + sub + '</small></div><button type="button" class="bd-toggle" role="switch" aria-checked="' + on + '" data-act="toggle" data-v="' + k + '"><i></i><span class="fl-sr">' + t + '</span></button></div>'; };

  var drawerHtml = function () {
    var d = ui.drawer;
    var h = '<div class="bd-drawer__top">' + (d.back ? '<button type="button" class="bd-iconb" data-act="session" data-v="' + d.back + '" aria-label="Back">' + ICON.left + '</button>' : '<span class="bd-iconb bd-iconb--spacer" aria-hidden="true"></span>') + '<b>' + (d.type === 'booking' ? 'Booking' : d.type === 'day' ? 'Day' : 'Session') + '</b><button type="button" class="bd-iconb" data-act="close" aria-label="Close">' + ICON.close + '</button></div><div class="bd-drawer__body">';
    if (d.type === 'session') {
      var p = d.v.split('|'); var svc = svcById(p[0]); var a = avail(svc, p[1], p[2]);
      var all = bookingsAt(svc, p[1], p[2]);
      h += '<h4>' + esc(svc.name) + '</h4><p class="bd-sub">' + esc(dayLong(p[1])) + ' · ' + p[2] + ' · ' + svc.mins + ' min</p>';
      h += '<div class="bd-cap"><div class="bd-cap__bar"><i style="width:' + (a.cap ? Math.min(100, Math.round(a.taken / a.cap * 100)) : 0) + '%"></i></div><span>' + (svc.perStaff ? a.taken + ' of ' + a.cap + ' ' + (B().staffNoun || 'chairs') + ' booked' : a.taken + ' of ' + a.cap + ' ' + esc(svc.unit[1]) + ' booked') + '</span></div>';
      var wl = waitFor(svc, p[1], p[2]);
      if (wl.length) h += '<div class="bd-note bd-note--pink">' + wl.length + ' on the waitlist: ' + esc(wl.map(function (w) { return w.name; }).join(', ')) + '</div>';
      if (!all.length) h += '<p class="bd-emptyrow">No bookings yet.</p>';
      all.forEach(function (b) { h += rowHtml(b).replace('data-act="booking" data-v="' + b.id + '"', 'data-act="booking" data-v="' + b.id + '" data-back="' + d.v + '"'); });
      if (all.filter(active).length) h += '<button type="button" class="bd-mini bd-mini--wide" data-act="msgall" data-v="' + d.v + '">' + ICON.chat + 'WhatsApp everyone in this session</button>';
    } else if (d.type === 'day') {
      h += '<h4>' + esc(dayLong(d.v)) + '</h4>';
      B().services.forEach(function (svc) { slotsFor(svc, d.v).forEach(function (t) { bookingsAt(svc, d.v, t).forEach(function (b) { h += rowHtml(b); }); }); });
    } else {
      var b = lookup(d.v); if (!b) return h + '<p class="bd-emptyrow">Booking not found.</p></div>';
      var svc2 = svcById(b.svc, b.biz); var sl = slotOf(b); var st = statusOf(b);
      var view = { svc: b.svc, biz: b.biz, date: sl.date, time: sl.time, qty: b.qty, names: b.names, staff: b.staff, total: b.total, paid: b.paid, status: st, seed: b.seed, id: b.id };
      h += '<h4>' + esc(b.name) + (!b.seed ? ' <i class="bd-new">New</i>' : '') + '</h4><p class="bd-sub">' + (b.phone ? esc(b.phone) + ' · ' : '') + (b.order ? 'Order #' + b.order : 'Order #' + (1000 + hash(b.id) % 40)) + '</p>';
      h += bookingCard(view, svc2);
      if (st === 'confirmed') {
        h += '<div class="bd-acts"><button type="button" class="bd-mini bd-mini--ink" data-act="attend" data-v="' + b.id + '">' + ICON.check + 'Check in</button><button type="button" class="bd-mini" data-act="noshow" data-v="' + b.id + '">No-show</button></div>';
        var alts = altSlots(view).slice(0, 8);
        h += '<div class="bd-label">Reschedule</div>';
        if (alts.length) {
          h += '<div class="bd-resched"><select data-in="resched" aria-label="New time">';
          alts.forEach(function (x, i) { var v = x.date + '|' + x.time; h += '<option value="' + v + '"' + ((ui.reschedTo ? ui.reschedTo === v : i === 0) ? ' selected' : '') + '>' + esc(dayLabel(x.date)) + ' · ' + x.time + '</option>'; });
          h += '</select><button type="button" class="bd-mini bd-mini--ink" data-act="move" data-v="' + b.id + '">Move</button></div>';
        } else h += '<p class="bd-sub">No other times with space.</p>';
        h += ui.confirmCancel === b.id ? '<button type="button" class="bd-mini bd-mini--danger bd-mini--wide" data-act="cancel-yes" data-v="' + b.id + '">Yes, cancel and refund ' + money(b.paid) + '</button><button type="button" class="bd-link bd-link--center" data-act="cancel-no">Keep it</button>'
          : '<button type="button" class="bd-mini bd-mini--wide bd-mini--line" data-act="cancel" data-v="' + b.id + '">Cancel and refund</button>';
      } else if (st === 'attended' || st === 'noshow') {
        h += '<button type="button" class="bd-mini bd-mini--wide" data-act="undo" data-v="' + b.id + '">Undo</button>';
      }
    }
    return h + '</div>';
  };
  var lookup = function (id) {
    var b = findBooking(id); if (b) return b;
    var o = S.over[id];
    if (o && o.from) { var f = findSeed(id, o); if (f) return f; }
    // search seeded bookings in the next 14 days
    var found = null;
    B().services.forEach(function (svc) { if (found) return; dates().forEach(function (ds) { if (found) return; slotsFor(svc, ds).forEach(function (t) { if (found) return; seeded(S.biz, svc, ds, t).forEach(function (x) { if (x.id === id) found = x; }); }); }); });
    return found;
  };
  var setStatus = function (b, st) {
    if (b.seed) { S.over[b.id] = S.over[b.id] || { biz: b.biz, svc: b.svc }; S.over[b.id].status = st; }
    else b.status = st;
  };

  /* free a space: offer it to the waitlist */
  var afterFree = function (svc, date, time) {
    var wl = waitFor(svc, date, time).filter(function (w) { return w.status === 'waiting'; });
    if (!wl.length) return '';
    var a = avail(svc, date, time);
    var w = wl[0];
    var fits = svc.perStaff ? a.left > 0 : a.left >= w.qty;
    if (!fits) return '';
    w.status = 'offered';
    showWa(waMsg({ biz: w.biz, svc: w.svc, date: date, time: time, name: w.name, qty: w.qty }, 'offer'), w.id, true);
    return ' Space offered to ' + w.name + ' on WhatsApp.';
  };

  /* ---------------- actions ---------------- */
  var nextOrder = function () { S.order += 1; return S.order; };
  var actions = {
    biz: function (v) { if (!BIZ[v] || v === S.biz) return; S.biz = v; save(); ui.screen = 'pick'; ui.cart = null; ui.upsell = false; ui.drawer = null; ui.wa = null; ui.last = null; ui.search = ''; resetPick(); root.querySelectorAll('[data-act="biz"]').forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-v') === v ? 'true' : 'false'); }); },
    view: function (v) { ui.view = v; if (v === 'admin') ui.badge = false; grid.setAttribute('data-view', v); root.querySelectorAll('[data-act="view"]').forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-v') === v ? 'true' : 'false'); }); if (v === 'admin' && window.innerWidth < 760) { root.querySelector('.bd-view').scrollIntoView({ behavior: 'smooth', block: 'start' }); } },
    svc: function (v) { resetPick(v); },
    date: function (v) { ui.date = v; var svc = svcById(ui.svc); var ts = slotsFor(svc, v); ui.time = null; for (var i = 0; i < ts.length; i++) { if (!isPast(v, ts[i]) && avail(svc, v, ts[i]).left > 0) { ui.time = ts[i]; break; } } if (!ui.time && ts.length) { for (var j = 0; j < ts.length; j++) if (!isPast(v, ts[j])) { ui.time = ts[j]; break; } } ui.screen = 'pick'; },
    time: function (v) { ui.time = v; },
    staff: function (v) {
      ui.staff = v; var svc = svcById(ui.svc);
      var freeAt = function (ds, t) { if (isPast(ds, t)) return false; var a = avail(svc, ds, t); return v === 'any' ? a.left > 0 : a.free.indexOf(v) !== -1; };
      var ds0 = [ui.date].concat(dates().filter(function (d) { return d > ui.date; }));
      for (var i = 0; i < ds0.length; i++) { var ts = slotsFor(svc, ds0[i]); for (var j = 0; j < ts.length; j++) { if (freeAt(ds0[i], ts[j])) { ui.date = ds0[i]; ui.time = ts[j]; return; } } }
    },
    qty: function (v) { ui.qty = Math.max(1, ui.qty + (+v)); },
    add: function () {
      var svc = svcById(ui.svc); var a = avail(svc, ui.date, ui.time);
      var staff = null;
      if (svc.perStaff) { staff = ui.staff !== 'any' ? ui.staff : a.free[0]; if (!staff || a.free.indexOf(staff) === -1) return; }
      else if (a.left < ui.qty) return;
      var total = svc.price * ui.qty;
      ui.cart = { svc: svc.id, date: ui.date, time: ui.time, qty: ui.qty, names: ui.names.slice(0, ui.qty), staff: staff, total: total, paid: depositFor(total, ui.qty) };
      ui.screen = 'cart'; sound('tick');
    },
    upsell: function () { ui.upsell = !ui.upsell; },
    remove: function () { ui.cart = null; ui.upsell = false; ui.screen = 'pick'; },
    go: function (v) { ui.err = ''; ui.screen = v; if (v === 'done' && !ui.last) ui.screen = 'pick'; },
    pay: function () {
      if (!ui.cart) return;
      if (!(ui.cname || '').trim()) { ui.err = 'Add your name so the studio knows who’s coming.'; return; }
      ui.err = ''; ui.paying = true; renderShop();
      setTimeout(function () {
        ui.paying = false;
        var c = ui.cart; var svc = svcById(c.svc);
        var a = avail(svc, c.date, c.time);
        if ((svc.perStaff && a.free.indexOf(c.staff) === -1) || (!svc.perStaff && a.left < c.qty)) { ui.err = 'Someone just took that time. Pick another one.'; ui.screen = 'pick'; renderAll(); return; }
        var b = { id: 'u' + Date.now().toString(36), biz: S.biz, svc: c.svc, date: c.date, time: c.time, qty: c.qty, names: c.names, staff: c.staff, total: c.total, paid: c.paid, status: 'confirmed', name: ui.cname.trim(), phone: (ui.cphone || '').trim(), order: nextOrder(), upsell: ui.upsell ? B().upsell.name : '' };
        S.bookings.push(b); save();
        ui.last = b.id; ui.cart = null; ui.upsell = false; ui.screen = 'done';
        showWa(waMsg(b, 'book'));
        adminToast('New booking: ' + b.name + ', ' + svc.short + ' ' + dayLabel(b.date) + ' ' + b.time + (b.paid ? ' · ' + money(b.paid) + ' paid' : ''));
        ui.tab = 'cal'; ui.week = 0; ui.drawer = null;
        sound('success');
        renderAll();
      }, 900);
    },
    again: function () { ui.screen = 'pick'; ui.wa = null; resetPick(ui.svc); },
    'wa-close': function () { ui.wa = null; },
    waitlist: function () { ui.screen = 'waitform'; ui.err = ''; },
    joinwait: function () {
      if (!(ui.cname || '').trim()) { ui.err = 'Add your name so we know who to message.'; return; }
      var svc = svcById(ui.svc);
      var w = { id: 'w' + Date.now().toString(36), biz: S.biz, svc: svc.id, date: ui.date, time: ui.time, qty: ui.qty || 1, staff: ui.staff, name: ui.cname.trim(), phone: (ui.cphone || '').trim(), status: 'waiting' };
      S.waitlist.push(w); save();
      ui.last = w.id; ui.screen = 'waitdone'; ui.err = '';
      showWa(waMsg(w, 'wait'));
      adminToast('Waitlist: ' + w.name + ' for ' + svc.short + ' ' + dayLabel(w.date) + ' ' + w.time);
      sound('tick');
    },
    ics: function (v) {
      var b = findBooking(v); if (!b) return;
      var svc = svcById(b.svc, b.biz); var d = parse(b.date); var st = mins(b.time); var en = st + svc.mins;
      var dt = function (m) { return '' + d.getFullYear() + pad(d.getMonth() + 1) + pad(d.getDate()) + 'T' + pad(Math.floor(m / 60)) + pad(m % 60) + '00'; };
      var stamp = new Date().toISOString().replace(/[-:]/g, '').replace(/\.\d+/, '');
      var ics = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Fun Life//Bhuka demo//EN', 'BEGIN:VEVENT', 'UID:' + b.id + '@bhuka-demo', 'DTSTAMP:' + stamp, 'DTSTART:' + dt(st), 'DTEND:' + dt(en), 'SUMMARY:' + svc.name + ' (' + BIZ[b.biz].name + ')', 'DESCRIPTION:Demo booking made with Bhuka on funlife.co.za', 'END:VEVENT', 'END:VCALENDAR'].join('\r\n');
      try {
        var url = URL.createObjectURL(new Blob([ics], { type: 'text/calendar' }));
        var a = document.createElement('a'); a.href = url; a.download = 'bhuka-demo-booking.ics'; document.body.appendChild(a); a.click();
        setTimeout(function () { URL.revokeObjectURL(url); a.remove(); }, 500);
      } catch (e) {}
    },
    manage: function (v) { ui.manage = v; ui.screen = 'manage'; ui.confirmCancel = null; },
    cmove: function (v) {
      var b = findBooking(ui.manage); if (!b) return; var p = v.split('|'); var from = b.date + '|' + b.time;
      var svc = svcById(b.svc, b.biz); b.date = p[0]; b.time = p[1];
      if (svc.perStaff) { var a = avail(svc, p[0], p[1]); if (a.free.indexOf(b.staff) === -1) b.staff = a.free[0] || b.staff; }
      save(); showWa(waMsg(b, 'move'));
      var f = from.split('|'); var extra = afterFree(svc, f[0], f[1]); save();
      adminToast(b.name + ' moved to ' + dayLabel(b.date) + ' ' + b.time + '.' + extra);
    },
    ccancel: function (v) { ui.confirmCancel = v; },
    'ccancel-no': function () { ui.confirmCancel = null; },
    'ccancel-yes': function (v) {
      var b = findBooking(v); if (!b) return; var svc = svcById(b.svc, b.biz);
      b.status = 'cancelled'; ui.confirmCancel = null; save();
      showWa(waMsg(b, 'cancel'));
      var extra = afterFree(svc, b.date, b.time); save();
      adminToast(b.name + ' cancelled · ' + money(b.paid) + ' refunded.' + extra);
    },
    /* admin */
    tab: function (v) { ui.tab = v; ui.drawer = null; ui.confirmCancel = null; },
    week: function (v) { ui.week = +v; },
    session: function (v) { if (!v) { ui.drawer = null; return; } ui.drawer = { type: 'session', v: v }; ui.confirmCancel = null; },
    day: function (v) { ui.drawer = { type: 'day', v: v }; },
    booking: function (v, el) { ui.drawer = { type: 'booking', v: v, back: el.getAttribute('data-back') || (ui.drawer && ui.drawer.type === 'session' ? ui.drawer.v : '') }; ui.confirmCancel = null; ui.reschedTo = ''; },
    close: function () { ui.drawer = null; ui.confirmCancel = null; },
    attend: function (v) { var b = lookup(v); if (b) { setStatus(b, 'attended'); save(); adminToast(b.name + ' checked in.'); } },
    noshow: function (v) { var b = lookup(v); if (b) { setStatus(b, 'noshow'); save(); adminToast(b.name + ' marked as a no-show. Deposit kept.'); } },
    undo: function (v) { var b = lookup(v); if (b) { setStatus(b, 'confirmed'); save(); } },
    cancel: function (v) { ui.confirmCancel = v; },
    'cancel-no': function () { ui.confirmCancel = null; },
    'cancel-yes': function (v) {
      var b = lookup(v); if (!b) return; var svc = svcById(b.svc, b.biz); var sl = slotOf(b);
      setStatus(b, 'cancelled'); ui.confirmCancel = null; save();
      var extra = afterFree(svc, sl.date, sl.time); save();
      if (!b.seed) showWa(waMsg(b, 'cancel'));
      adminToast(b.name + ' cancelled · ' + money(b.paid) + ' refunded.' + extra);
    },
    move: function (v) {
      var b = lookup(v); if (!b) return; var sel = adminEl.querySelector('[data-in="resched"]'); if (!sel) return;
      var p = sel.value.split('|'); var svc = svcById(b.svc, b.biz); var sl = slotOf(b); var from = sl.date + '|' + sl.time;
      if (b.seed) {
        var o = S.over[b.id] = S.over[b.id] || { biz: b.biz, svc: b.svc };
        if (!o.from) o.from = b.date + '|' + b.time;
        o.date = p[0]; o.time = p[1];
      } else { b.date = p[0]; b.time = p[1]; }
      if (svc.perStaff) { var a = avail(svc, p[0], p[1]); if (a.free.indexOf(b.staff) === -1 && a.free.length) { if (b.seed) S.over[b.id].staff = a.free[0]; else b.staff = a.free[0]; } }
      save();
      var f = from.split('|'); var extra = afterFree(svc, f[0], f[1]); save();
      if (!b.seed) showWa(waMsg(b, 'move'));
      ui.drawer = { type: 'booking', v: b.id, back: '' };
      adminToast(b.name + ' moved to ' + dayLabel(p[0]) + ' ' + p[1] + '. They’ve been told on WhatsApp.' + extra);
    },
    msgall: function (v) { var p = v.split('|'); var svc = svcById(p[0]); var n = avail(svc, p[1], p[2]).list.length; adminToast('WhatsApp sent to ' + n + ' ' + (n === 1 ? 'person' : 'people') + ' (demo, nothing really sent).'); },
    offer: function (v) {
      var w = null; S.waitlist.forEach(function (x) { if (x.id === v) w = x; }); if (!w) return;
      w.status = 'offered'; save();
      showWa(waMsg({ biz: w.biz, svc: w.svc, date: w.date, time: w.time, name: w.name, qty: w.qty }, 'offer'), w.id, true);
      adminToast('Space offered to ' + w.name + ' on WhatsApp.');
    },
    claim: function (v) {
      var w = null; S.waitlist.forEach(function (x) { if (x.id === v) w = x; }); if (!w) return;
      var svc = svcById(w.svc, w.biz); var a = avail(svc, w.date, w.time);
      var staff = svc.perStaff ? (w.staff && w.staff !== 'any' && a.free.indexOf(w.staff) !== -1 ? w.staff : a.free[0]) : null;
      if ((svc.perStaff && !staff) || (!svc.perStaff && a.left < w.qty)) { adminToast('That space has gone again.'); w.status = 'waiting'; save(); return; }
      var total = svc.price * w.qty;
      var b = { id: 'u' + Date.now().toString(36), biz: w.biz, svc: w.svc, date: w.date, time: w.time, qty: w.qty, names: [], staff: staff, total: total, paid: depositFor(total, w.qty), status: 'confirmed', name: w.name, phone: w.phone, order: nextOrder() };
      S.bookings.push(b); w.status = 'booked'; save();
      ui.last = b.id; ui.screen = 'done'; showWa(waMsg(b, 'book'));
      adminToast(w.name + ' claimed the space · ' + money(b.paid) + ' paid.');
      sound('success');
    },
    dep: function (v) { var s = set(); s.deposit = v === 'pct' ? { type: 'pct', value: 50 } : v === 'fixed' ? { type: 'fixed', value: 200 } : { type: 'full' }; save(); adminToast('Payment rule updated. The customer side shows it now.'); },
    cap: function (v) { var p = v.split('|'); var svc = svcById(p[0]); var s = set(); s.caps[svc.id] = Math.max(1, Math.min(40, capOf(svc) + (+p[1]))); save(); },
    toggle: function (v) { var s = set(); s[v] = !s[v]; save(); },
    reset: function () { store.clear(); S = fresh(); seedCache = {}; forcedCache = {}; ui.screen = 'pick'; ui.cart = null; ui.upsell = false; ui.last = null; ui.manage = null; ui.drawer = null; ui.wa = null; ui.tab = 'cal'; ui.week = 0; ui.search = ''; ui.cname = ''; ui.cphone = ''; resetPick(); root.querySelectorAll('[data-act="biz"]').forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-v') === 'art' ? 'true' : 'false'); }); adminToast('Demo reset.'); }
  };

  var renderAll = function () { renderShop(); renderAdmin(); };

  root.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target.closest('[data-act]') : null;
    if (!el || !root.contains(el) || el.disabled) return;
    var act = el.getAttribute('data-act');
    if (act === 'upsell' && el.tagName === 'INPUT') { actions.upsell(); renderShop(); return; }
    var fn = actions[act]; if (!fn) return;
    var keepScroll = el.closest('[data-bd-admin]') ? adminEl.querySelector('.bd-adm__body') : null;
    var st = keepScroll ? keepScroll.scrollTop : 0;
    var shopScreen = shopEl.querySelector('[data-bd-screen]'); var st2 = shopScreen ? shopScreen.scrollTop : 0;
    var screenBefore = ui.screen;
    fn(el.getAttribute('data-v'), el);
    renderAll();
    var b2 = adminEl.querySelector('.bd-adm__body'); if (b2 && keepScroll) b2.scrollTop = st;
    var s2 = shopEl.querySelector('[data-bd-screen]'); if (s2 && screenBefore === ui.screen) s2.scrollTop = st2;
    if (screenBefore !== ui.screen && s2 && getComputedStyle(s2).overflowY === 'visible') {
      var pane = shopEl.closest('.bd-pane') || shopEl, top = pane.getBoundingClientRect().top;
      if (top < 70) { try { window.scrollTo({ top: window.pageYOffset + top - 84, behavior: 'smooth' }); } catch (err) { window.scrollTo(0, window.pageYOffset + top - 84); } }
    }
    if (el.getAttribute('data-act') === 'cap' || el.getAttribute('data-act') === 'dep' || el.getAttribute('data-act') === 'toggle') { /* stay */ }
  });
  root.addEventListener('input', function (e) {
    var el = e.target; var k = el.getAttribute && el.getAttribute('data-in'); if (!k) return;
    if (k === 'name') ui.names[+el.getAttribute('data-i')] = el.value;
    else if (k === 'cname') ui.cname = el.value;
    else if (k === 'cphone') ui.cphone = el.value;
    else if (k === 'resched') ui.reschedTo = el.value;
    else if (k === 'search') {
      ui.search = el.value;
      var holder = adminEl.querySelector('[data-bd-list]');
      if (holder) {
        var days = []; for (var i = 0; i < 7; i++) days.push(ymd(addDays(TODAY, i)));
        var q = ui.search.toLowerCase();
        var match = function (b) { return !q || (b.name + ' ' + svcById(b.svc, b.biz).name + ' ' + (b.staff || '')).toLowerCase().indexOf(q) !== -1; };
        var seeds = allIn(days).filter(function (b) { return b.seed; });
        seeds.sort(function (x, y) { var a = slotOf(x), b = slotOf(y); return a.date === b.date ? mins(a.time) - mins(b.time) : a.date < b.date ? -1 : 1; });
        holder.innerHTML = listRows(S.bookings.filter(function (b) { return b.biz === S.biz; }).slice().reverse().filter(match), seeds.filter(match));
      }
    }
  });
  root.addEventListener('change', function (e) { var el = e.target; if (el.getAttribute && el.getAttribute('data-in') === 'resched') ui.reschedTo = el.value; });
  root.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && ui.drawer) { ui.drawer = null; renderAdmin(); }
    if (e.key === 'Enter' && e.target.getAttribute && (e.target.getAttribute('data-in') === 'cname' || e.target.getAttribute('data-in') === 'cphone')) {
      e.preventDefault(); var go = ui.screen === 'waitform' ? actions.joinwait : actions.pay; go(); renderAll();
    }
  });

  root.querySelectorAll('[data-act="biz"]').forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-v') === S.biz ? 'true' : 'false'); });
  document.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target.closest('[data-bd-pick]') : null;
    if (!el || root.contains(el)) return;
    e.preventDefault();
    var v = el.getAttribute('data-bd-pick');
    if (v && v !== 'any') resetPick(v);
    ui.screen = 'pick'; ui.view = 'shop'; grid.setAttribute('data-view', 'shop');
    root.querySelectorAll('[data-act="view"]').forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-v') === 'shop' ? 'true' : 'false'); });
    renderAll();
    var target = document.getElementById(el.getAttribute('data-bd-target') || '') || root;
    try { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (err) { target.scrollIntoView(); }
  });
  root.classList.add('is-ready');
  resetPick();
  renderAll();
})();
